import { render, staticRenderFns } from "./message.vue?vue&type=template&id=ca887c0e&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "./message.vue?vue&type=style&index=0&id=ca887c0e&prod&lang=less&"
import style1 from "./message.vue?vue&type=style&index=1&id=ca887c0e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca887c0e",
  null
  
)

export default component.exports